import { Injectable } from '@angular/core';
import { FoodLogModel } from 'src/app/core/model/object/foodlog-model';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';

@Injectable({
  providedIn: 'root',
})
export class CanvasService {
  constructor(private calorieCalculator: CalorieCalculator) {}

  createCalorieImage(dateLabel: string, calorie: string) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const myGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    myGradient.addColorStop(0, 'rgb(43, 220, 137)');
    myGradient.addColorStop(1, 'rgb(158, 239, 201)');
    ctx.fillStyle = myGradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText('کالری مصرفی', 481, 42);

    ctx.font = '19px Vazir';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText(dateLabel, 481, 90);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'center';
    ctx.fillText(calorie, canvas.width / 2, canvas.height / 2 + 96);

    ctx.beginPath();
    ctx.arc(canvas.width / 2, canvas.height / 2, 64, 0, 2 * Math.PI);
    ctx.fillStyle = '#c5f5de';
    ctx.fill();

    let img = new Image();
    img.src = 'assets/general/calorie.png';
    ctx.drawImage(img, canvas.width / 2 - 34, canvas.height / 2 - 34, 68, 68);

    img = new Image();
    img.src = 'assets/blog/logo-white.svg';
    ctx.drawImage(img, 429, 429, 52, 52);

    setTimeout(() => {
      img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, 429, 429, 52, 52);
    }, 10);
  }

  createCalorieDetailImage(
    dateLabel: string,
    calorie: string,
    foodLogs: FoodLogModel[],
    meals: string[],
    mealNames: string[]
  ) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const myGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    myGradient.addColorStop(0, 'rgb(43, 220, 137)');
    myGradient.addColorStop(1, 'rgb(158, 239, 201)');
    ctx.fillStyle = myGradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText('کالری مصرفی', 481, 42);

    ctx.font = '19px Vazir';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText(dateLabel, 481, 80);

    let img = new Image();
    img.src = 'assets/general/calorie.png';
    ctx.drawImage(img, 449, 111, 32, 32);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText(calorie, 438, 133);
    meals.forEach((meal, i) => {
      const mealFoodLogs = foodLogs.filter((obj) => obj.meal === meal);

      ctx.beginPath();
      ctx.arc(
        424 - Math.floor(i / 3) * 224,
        203 + (i % 3) * 85,
        32,
        0,
        2 * Math.PI
      );
      ctx.fillStyle = '#d5f8e7';
      ctx.fill();

      img = new Image();
      img.src =
        'assets/plan/' +
        (meal.startsWith('snack') ? 'snack.png' : meal + '.png');
      ctx.drawImage(
        img,
        399 - Math.floor(i / 3) * 224,
        173 + (i % 3) * 85,
        53,
        53
      );

      const c =
        (mealFoodLogs
          ? this.calorieCalculator
              .calculateFoodLogsCalorie(mealFoodLogs)
              .toFixed(0)
          : '0') + ' کالری';
      ctx.font = '21px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText(c, 383 - Math.floor(i / 3) * 224, 192 + (i % 3) * 85);

      const m = mealNames[i];
      ctx.font = '17px Vazir';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText(m, 383 - Math.floor(i / 3) * 224, 224 + (i % 3) * 85);
    });

    img = new Image();
    img.src = 'assets/blog/logo-white.svg';
    ctx.drawImage(img, 429, 429, 52, 52);
  }

  createMealDetailImage(
    dateLabel: string,
    meal: FoodLogModel[],
    mealName: string
  ) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const myGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    myGradient.addColorStop(0, 'rgb(43, 220, 137)');
    myGradient.addColorStop(1, 'rgb(158, 239, 201)');
    ctx.fillStyle = myGradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const m = mealName;
    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText(m, 481, 42);

    ctx.font = '19px Vazir';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText(dateLabel, 481, 80);

    let img = new Image();
    img.src = 'assets/general/calorie.png';
    ctx.drawImage(img, 449, 111, 32, 32);

    ctx.font = '29px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText(
      this.calorieCalculator.calculateFoodLogsCalorie(meal).toFixed(0) +
        ' کالری',
      436,
      133
    );

    let needMoreText = false;
    meal.forEach((food, i) => {
      if (i < 5) {
        const foodName = food.foodModel.name;
        ctx.font = '21px Vazir';
        ctx.fillStyle = 'white';
        ctx.textAlign = 'right';
        const width = ctx.measureText(foodName).width;
        ctx.fillText(foodName, 468, 192 + i * 40);

        const foodCalorie =
          this.calorieCalculator.calculateFoodLogCalorie(food).toFixed(0) +
          ' کالری';
        ctx.font = '16px Vazir';
        ctx.fillStyle = 'white';
        ctx.textAlign = 'right';
        ctx.fillText(foodCalorie, 468 - width - 6, 192 + i * 40);
      } else {
        needMoreText = true;
      }
    });

    if (needMoreText) {
      ctx.font = '19px Vazir';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText('و چیزهای دیگر', 468, 192 + 5 * 40);
    }

    img = new Image();
    img.src = 'assets/blog/logo-white.svg';
    ctx.drawImage(img, 429, 429, 52, 52);

    setTimeout(() => {
      img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, 429, 429, 52, 52);
    }, 10);
  }

  createMealImage(
    dateLabel: string,
    meal: FoodLogModel[],
    image: HTMLImageElement,
    mealName: string
  ) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    setTimeout(() => {
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      const m = mealName;
      ctx.font = '24px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText(m, 481, 42);

      ctx.font = '19px Vazir';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText(dateLabel, 481, 80);

      const calorie =
        this.calorieCalculator.calculateFoodLogsCalorie(meal).toFixed(0) +
        ' کالری';
      ctx.font = '29px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      const width = ctx.measureText(calorie).width;
      ctx.fillText(calorie, 21 + width, 42);

      let img = new Image();
      img.src = 'assets/general/calorie.png';
      ctx.drawImage(img, 33 + width, 20, 32, 32);

      img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, 429, 429, 52, 52);
    }, 10);
  }

  createWaterDetailImage(dateLabel: string, waterLabel: string) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const myGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    myGradient.addColorStop(0, '#1981ff');
    myGradient.addColorStop(1, '#81baff');
    ctx.fillStyle = myGradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText('آب', 481, 42);

    ctx.font = '19px Vazir';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText(dateLabel, 481, 80);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'center';
    ctx.fillText(waterLabel, canvas.width / 2, canvas.height / 2 + 96);

    ctx.beginPath();
    ctx.arc(canvas.width / 2, canvas.height / 2, 64, 0, 2 * Math.PI);
    ctx.fillStyle = '#c5f5de';
    ctx.fill();

    let img = new Image();
    img.src = 'assets/plan/waterFull.svg';
    ctx.drawImage(img, canvas.width / 2 - 23, canvas.height / 2 - 34, 46, 68);

    img = new Image();
    img.src = 'assets/blog/logo-white.svg';
    ctx.drawImage(img, 429, 429, 52, 52);

    setTimeout(() => {
      img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, 429, 429, 52, 52);
    }, 10);
  }

  createWaterImage(
    dateLabel: string,
    waterLabel: string,
    image: HTMLImageElement
  ) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    setTimeout(() => {
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      ctx.font = '24px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText('آب', 481, 42);

      ctx.font = '19px Vazir';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText(dateLabel, 481, 80);

      ctx.font = '29px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      const width = ctx.measureText(waterLabel).width;
      ctx.fillText(waterLabel, 21 + width, 42);

      const img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, 429, 429, 52, 52);
    }, 10);
  }

  createWeightDetailImage(dateLabel: string, weightLabel: string) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const myGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    myGradient.addColorStop(0, '#443d99');
    myGradient.addColorStop(1, '#7771b4');
    ctx.fillStyle = myGradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText('وزن', 481, 42);

    ctx.font = '19px Vazir';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText(dateLabel, 481, 80);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'center';
    ctx.fillText(weightLabel, canvas.width / 2, canvas.height / 2 + 96);

    ctx.beginPath();
    ctx.arc(canvas.width / 2, canvas.height / 2, 64, 0, 2 * Math.PI);
    ctx.fillStyle = '#c5f5de';
    ctx.fill();

    let img = new Image();
    img.src = 'assets/plan/weightIcon.png';
    ctx.drawImage(img, canvas.width / 2 - 34, canvas.height / 2 - 34, 68, 68);

    img = new Image();
    img.src = 'assets/blog/logo-white.svg';
    ctx.drawImage(img, 429, 429, 52, 52);

    setTimeout(() => {
      img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, 429, 429, 52, 52);
    }, 10);
  }

  createWeightImage(
    dateLabel: string,
    weightLabel: string,
    image: HTMLImageElement
  ) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    setTimeout(() => {
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      ctx.font = '24px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText('وزن', 481, 42);

      ctx.font = '19px Vazir';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText(dateLabel, 481, 80);

      ctx.font = '29px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      const width = ctx.measureText(weightLabel).width;
      ctx.fillText(weightLabel, 21 + width, 42);

      const img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, 429, 429, 52, 52);
    }, 10);
  }
  createClearBeforeAfter() {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const myGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    myGradient.addColorStop(0, '#6d7278');
    myGradient.addColorStop(1, '#5e5e5e');
    ctx.fillStyle = myGradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText('قبل', 400, 450);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText('بعد', 150, 450);

    const img = new Image();
    img.src = 'assets/blog/logo-white.svg';
    ctx.drawImage(img, canvas.width / 2 - 26, 429, 52, 52);

    setTimeout(() => {
      const img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, canvas.width / 2 - 26, 429, 52, 52);
    }, 10);
  }
  createBeforeAfterImage(
    before: HTMLImageElement,
    after: HTMLImageElement,
    beforeDate?: string,
    afterDate?: string
  ) {
    const canvas = document.getElementById(
      'canvasCreateImage'
    ) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (before) {
      ctx.drawImage(
        before,
        canvas.width / 2,
        0,
        canvas.width / 2,
        canvas.height
      );
    }
    if (after) {
      ctx.drawImage(after, 0, 0, canvas.width / 2, canvas.height);
    }

    if (beforeDate) {
      ctx.font = '19px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'center';
      ctx.fillText(beforeDate, 380, 480);
    }
    if (afterDate) {
      ctx.font = '19px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'center';
      ctx.fillText(afterDate, 130, 480);
    }
    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText('قبل', 400, 450);

    ctx.font = '24px Vazir-Medium';
    ctx.fillStyle = 'white';
    ctx.textAlign = 'right';
    ctx.fillText('بعد', 150, 450);

    const img = new Image();
    img.src = 'assets/blog/logo-white.svg';
    ctx.drawImage(img, canvas.width / 2 - 26, 429, 52, 52);

    setTimeout(() => {
      if (before) {
        ctx.drawImage(
          before,
          canvas.width / 2,
          0,
          canvas.width / 2,
          canvas.height
        );
      }
      if (after) {
        ctx.drawImage(after, 0, 0, canvas.width / 2, canvas.height);
      }

      if (beforeDate) {
        ctx.font = '19px Vazir-Medium';
        ctx.fillStyle = 'white';
        ctx.textAlign = 'center';
        ctx.fillText(beforeDate, 380, 480);
      }
      if (afterDate) {
        ctx.font = '19px Vazir-Medium';
        ctx.fillStyle = 'white';
        ctx.textAlign = 'center';
        ctx.fillText(afterDate, 130, 480);
      }

      ctx.font = '24px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText('قبل', 400, 450);

      ctx.font = '24px Vazir-Medium';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'right';
      ctx.fillText('بعد', 150, 450);

      const img = new Image();
      img.src = 'assets/blog/logo-white.svg';
      ctx.drawImage(img, canvas.width / 2 - 26, 429, 52, 52);
    }, 3);
  }
}
